import { useSelector } from 'react-redux';
import { useState } from 'react';
import EnabledToggle from '../formFields/EnabledToggle';
import AttributeField from '../formFields/AttributeField';
import ServicesDropdown from '../formFields/ServicesDropdown';

const OperatorPlatformSection = ({
    errors,
    touched,
    submitData,
    setSubmitData,
    platformID,
    services,
}) => {
    const { darkMode } = useSelector((state) => state.settings);
    const { currentScope } = useSelector((state) => {
        return { ...state.login };
    });
    const section = 'operatorPlatform';
    const [isChecked, setIsChecked] = useState(
        !!submitData?.find((platform) => platform?.platformID === platformID)
            ?.trunkID || false,
    );
    const serviceList = Array.isArray(services)
        ? services
        : services
          ? [services]
          : [];
    const serviceCount = serviceList.length;
    const [selectedService, setSelectedService] = useState(
        submitData?.find((platform) => platform?.platformID === platformID)
            ?.trunkID || null,
    );
    const isServiceDisabled = serviceCount === 0;

    const fields = [
        <EnabledToggle
            key={`${section}-enabled-toggle`}
            submitData={submitData}
            setPlatformNumber={setSubmitData}
            errors={errors}
            touched={touched}
            darkMode={darkMode}
            section={section}
            platformID={platformID}
            setIsChecked={setIsChecked}
            trunkList={serviceList}
            isTrunkDisabled={isServiceDisabled}
            setSelectedTrunk={setSelectedService}
            selectedTrunk={selectedService}
            isChecked={isChecked}
        />,
        isChecked && (
            <ServicesDropdown
                key={`${section}-services-field`}
                errors={errors}
                touched={touched}
                darkMode={darkMode}
                submitData={submitData}
                setPlatformNumber={setSubmitData}
                platformID={platformID}
                services={services}
                serviceList={serviceList}
                serviceCount={serviceCount}
                section={section}
                isServiceDisabled={isServiceDisabled}
            />
        ),
        isChecked &&
            currentScope >= 60 &&
            [1, 2, 3].map((num) => (
                <AttributeField
                    key={`operatorPlatformAttribute${num}`}
                    setPlatformNumber={setSubmitData}
                    errors={errors}
                    touched={touched}
                    darkMode={darkMode}
                    number={num}
                    submitData={submitData}
                    platformID={platformID}
                />
            )),
    ];

    return fields.filter(Boolean);
};

export default OperatorPlatformSection;
